import {
  Grid,
  TextField,
  type TextFieldProps,
  Typography
} from "@mui/material";
import { withStyles } from "@mui/styles";
import { forwardRef } from "react";

import SearchTextField from "@/components/sitehub-ui/atoms/SearchTextField";

import styles from "./AppTextField.module.css";

export type AppTextFieldProps = Omit<TextFieldProps, "size" | "variant"> & {
  size?: "sm" | "lg" | "xs";
  variant?: "outlined" | "standard" | "online_outline" | "standard_transparent";
  containerStyle?: React.CSSProperties;
  clearableSearch?: boolean;
  onClearSearch?: () => void;
};

const AppTextField = withStyles(() => ({
  root: {
    borderRadius: "4px",
    width: "100%",
    "& label.Mui-focused": {
      color: "var(--app-font-light)"
    },
    "& .MuiOutlinedInput-root": {
      borderWidth: "0px",
      color: "var(--app-font-light)",
      "& fieldset": {
        borderWidth: "0px",
        minHeight: "36px"
      },
      "&.Mui-focused fieldset": {
        borderWidth: "0px"
      }
    },
    "& .MuiOutlinedInput-input": {
      padding: "4px 16px",
      minHeight: "24px",
      lineHeight: "36px",
      fontSize: "14px",
      borderRadius: "4px"
    },
    "& .MuiInputLabel-outlined": {
      transform: "translate(14px, 10px) scale(1)"
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)"
    },
    "& .MuiOutlinedInput-multiline": {
      padding: "4px 16px"
    },
    "& .MuiInputBase-multiline": {
      padding: "4px 8px",
      "& .MuiInputBase-inputMultiline": {
        padding: "0px"
      }
    }
  }
}))(
  forwardRef(
    (
      {
        size = "lg",
        variant = "standard",
        containerStyle,
        clearableSearch,
        onClearSearch,
        ...props
      }: AppTextFieldProps,
      ref?: any
    ) => {
      const Field = clearableSearch ? SearchTextField : TextField;
      return (
        <Grid container direction="column" rowGap={1} style={containerStyle}>
          <Field
            {...(clearableSearch ? { onClearSearch } : {})}
            ref={ref}
            className={styles.input}
            {...props}
            error={false}
            helperText={null}
            style={{
              ...props.style,
              height: props.multiline
                ? "100%"
                : size === "lg"
                  ? "40px"
                  : size === "xs"
                    ? "32px"
                    : "36px",
              paddingTop:
                size === "lg" && variant !== "standard_transparent"
                  ? "4px"
                  : "0px",
              backgroundColor:
                props.style?.backgroundColor !== undefined
                  ? props.style.backgroundColor
                  : variant !== "online_outline" &&
                      variant !== "standard_transparent"
                    ? "var(--app-input-bg-color)"
                    : "",
              border:
                props.style?.border !== undefined
                  ? props.style.border
                  : variant === "standard" || variant === "standard_transparent"
                    ? "none"
                    : "1px solid var(--app-input-border-color)"
            }}
          />
          {props.error && props.helperText ? (
            <Typography variant="caption" color="red">
              {props.helperText}
            </Typography>
          ) : null}
        </Grid>
      );
    }
    // )
  )
);

export default AppTextField;
